import { GlobalResponseObject } from "../../../global-response-object"
import { PlannedActualRejGarmentsModel } from "./planned-actual-rej-garments.model";


export class PlannedActualRejGarmentsResponse extends GlobalResponseObject {
    data?:PlannedActualRejGarmentsModel;
    constructor(status: boolean, intlCode: number, internalMessage: string, data?:PlannedActualRejGarmentsModel){
        super(status,intlCode,internalMessage)
        this.data = data;
    }
}